var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:project-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.72949 17.625H8.60449C8.70762 17.625 8.79199 17.5406 8.79199 17.4375V6.5625C8.79199 6.45937 8.70762 6.375 8.60449 6.375H6.72949C6.62637 6.375 6.54199 6.45937 6.54199 6.5625V17.4375C6.54199 17.5406 6.62637 17.625 6.72949 17.625ZM11.2295 11.0625H13.1045C13.2076 11.0625 13.292 10.9781 13.292 10.875V6.5625C13.292 6.45937 13.2076 6.375 13.1045 6.375H11.2295C11.1264 6.375 11.042 6.45937 11.042 6.5625V10.875C11.042 10.9781 11.1264 11.0625 11.2295 11.0625ZM15.7295 12.75H17.6045C17.7076 12.75 17.792 12.6656 17.792 12.5625V6.5625C17.792 6.45937 17.7076 6.375 17.6045 6.375H15.7295C15.6264 6.375 15.542 6.45937 15.542 6.5625V12.5625C15.542 12.6656 15.6264 12.75 15.7295 12.75ZM20.792 2.625H3.54199C3.12715 2.625 2.79199 2.96016 2.79199 3.375V20.625C2.79199 21.0398 3.12715 21.375 3.54199 21.375H20.792C21.2068 21.375 21.542 21.0398 21.542 20.625V3.375C21.542 2.96016 21.2068 2.625 20.792 2.625ZM19.8545 19.6875H4.47949V4.3125H19.8545V19.6875Z",
    fill: "#BEBEBE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.f1412f8802f0fa85ba3ddd61fd883328.svg";
export { ForwardRef as ReactComponent };